"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageWidgetMarginOption = exports.MAX_SCALE = exports.MIN_SCALE = void 0;
var lodash_1 = __importDefault(require("lodash"));
var mobx_1 = require("mobx");
var mobx_react_1 = require("mobx-react");
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var WidgetManager_1 = require("../../WidgetManager");
var ImageWidgetMenu_1 = __importStar(require("./ImageWidgetMenu/ImageWidgetMenu"));
var UploadStore_1 = require("Common/Upload/UploadStore");
var LoadingPillbox_1 = __importDefault(require("Common/AtomicUI/LoadingPillbox/LoadingPillbox"));
var UploadService_1 = require("Common/Upload/UploadService");
var Image_1 = __importDefault(require("./Image/Image"));
var Image_2 = require("ContentTokens/DataModels/Image");
var EditorTypes_1 = require("Project/QwilrEditor/EditorTypes");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var VariableActions_1 = require("Project/QwilrEditor/Behaviours/VariableActions");
var WidgetBehaviours_1 = require("Project/QwilrEditor/Behaviours/WidgetBehaviours");
var WidgetTokenDropArea_1 = require("../WidgetTokenDropArea/WidgetTokenDropArea");
var RainbowLoadingBar_1 = __importDefault(require("Common/AtomicUI/RainbowLoadingBar/RainbowLoadingBar"));
var Types_1 = require("Tokens/Types");
var ResizerComponent_1 = __importDefault(require("../ResizerComponent/ResizerComponent"));
exports.MIN_SCALE = 1;
exports.MAX_SCALE = 3;
var ImageWidgetMarginOption;
(function (ImageWidgetMarginOption) {
    ImageWidgetMarginOption["None"] = "none";
    ImageWidgetMarginOption["BottomOnly"] = "bottom";
    ImageWidgetMarginOption["Both"] = "both";
})(ImageWidgetMarginOption = exports.ImageWidgetMarginOption || (exports.ImageWidgetMarginOption = {}));
var ImageWidget = (function (_super) {
    __extends(ImageWidget, _super);
    function ImageWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.menuState = ImageWidgetMenu_1.ImageWidgetMenuState.None;
        _this.renderInner = function () {
            var _a = _this.props, frame = _a.frame, width = _a.width, scale = _a.scale, translationX = _a.translationX, translationY = _a.translationY, variable = _a.variable, selectedEmptyInner = _a.selectedEmptyInner, enableTokens = _a.enableTokens, alt = _a.alt, role = _a.role;
            if ((enableTokens !== Types_1.TokensEnableState.Disabled && _this.hasNoImageAndIsntUploading()) ||
                !lodash_1.default.isUndefined(variable)) {
                var customDragDrop = {
                    isSupportedType: _this.isSupportedDragType,
                    customDragMessage: "Release to add image",
                };
                var instructions = enableTokens === Types_1.TokensEnableState.EnabledWithoutDragAndDrop
                    ? "Click to browse images, or add a token"
                    : "Drag an image or token in, or click to browse images";
                return (react_1.default.createElement("div", { className: "image-widget__frame" },
                    react_1.default.createElement(WidgetTokenDropArea_1.WidgetTokenDropArea, { isSelected: false, variableName: variable === null || variable === void 0 ? void 0 : variable.name, onDrop: _this.onEmptyImageDrop, onDropAreaClick: _this.chooseImage, selectedEmptyInner: selectedEmptyInner, customDragDrop: customDragDrop, instructions: instructions, icon: icons_1.Image })));
            }
            else {
                return (react_1.default.createElement(Image_1.default, { src: _this.props.src || (_this.uploadProgress && _this.uploadProgress.dataUrl), alt: alt, role: role, frame: frame, handleImageLoad: _this.handleImageLoad, width: width, scale: _this.isRepositionMode ? _this.tempScale : scale, translationX: _this.isRepositionMode ? _this.tempTranslation.x : translationX, translationY: _this.isRepositionMode ? _this.tempTranslation.y : translationY, aspectRatio: _this.aspectRatio != undefined ? _this.aspectRatio : 1, isRepositioningMode: _this.isRepositionMode, uploadPercent: _this.uploadProgress && _this.uploadProgress.percent, finishReposition: _this.updateTranslation }));
            }
        };
        _this.handleImageLoad = function (e) {
            var imageElem = e.target;
            if (!_this.props.uploadId && !_this.props.src) {
                return;
            }
            if (!imageElem ||
                !imageElem.parentElement ||
                !imageElem.parentElement.parentElement ||
                !imageElem.parentElement.parentElement.parentElement) {
                return;
            }
            var newImageData = {};
            if (!_this.props.width) {
                var containerWidth = imageElem.parentElement.parentElement.parentElement.getBoundingClientRect().width;
                var naturalWidth = Math.min((imageElem.naturalWidth / containerWidth) * 100, 100);
                newImageData.width = naturalWidth;
            }
            var newAspectRatio = imageElem.naturalWidth / imageElem.naturalHeight;
            if (_this.aspectRatio !== newAspectRatio) {
                _this.aspectRatio = newAspectRatio;
                newImageData.aspectRatio = _this.aspectRatio;
            }
            if (Object.keys(newImageData).length > 0) {
                _this.updateImage(newImageData);
            }
            _this.imageElem = imageElem.parentElement.parentElement;
        };
        _this.renderLoading = function () {
            var uploadProgress = _this.uploadProgress;
            if (!uploadProgress) {
                return;
            }
            switch (uploadProgress.state) {
                case UploadService_1.UploadState.Pending: {
                    var percent = uploadProgress.percent;
                    return (react_1.default.createElement("div", { className: "image-widget__uploading-container center" },
                        react_1.default.createElement("div", { className: "image-widget__uploading-veil", style: {
                                opacity: (100 - percent) / 1000,
                            } }),
                        react_1.default.createElement(RainbowLoadingBar_1.default, { percent: percent }),
                        react_1.default.createElement(LoadingPillbox_1.default, { percent: percent, message: "uploading", className: "image-widget__uploading-box" })));
                }
                case UploadService_1.UploadState.Error: {
                    return (react_1.default.createElement("div", { className: "image-widget__uploading-container center" },
                        react_1.default.createElement("div", { className: "image-widget__uploading-veil image-widget__uploading-veil--failed" }),
                        react_1.default.createElement("div", { onClick: _this.retryUpload },
                            react_1.default.createElement(icons_1.Retry, { className: "image-widget__retry" }),
                            react_1.default.createElement("div", { className: "pillbox-label pillbox-label--red loading-pillbox" }, "Upload failed"))));
                }
            }
        };
        _this.renderMenu = function (widthPercent) {
            var _a;
            var _b = _this.props, href = _b.href, telemetry = _b.telemetry, alignment = _b.alignment, frame = _b.frame, enableImageFrames = _b.enableImageFrames, enableTokens = _b.enableTokens, variable = _b.variable, alt = _b.alt, role = _b.role, width = _b.width;
            return (react_1.default.createElement(ImageWidgetMenu_1.default, { updateImage: _this.updateImage, href: href || "", alt: alt, role: role, deleteImage: _this.delete, imageElem: _this.imageElem, menuState: _this.menuState, onChangeMenuState: _this.onMenuStateChange, onMenuStateToggle: _this.onMenuStateToggle, telemetry: telemetry, alignment: alignment, disableLeftAlignment: width === "wide" || width === "full", frame: frame, aspectRatio: _this.aspectRatio, width: widthPercent, enableImageFrames: enableImageFrames, selectFrameType: _this.selectFrameType, startRepositioning: _this.startRepositioning, showTokensButton: enableTokens !== Types_1.TokensEnableState.Disabled, hasTokenSet: !!((_a = _this.props.variable) === null || _a === void 0 ? void 0 : _a.name), zoomIn: _this.zoomIn, zoomOut: _this.zoomOut, setZoomLevel: _this.setZoomLevel, currentZoom: _this.tempScale, confirmRepositioning: _this.confirmRepositioning, cancelRepositioning: _this.cancelRepositioning, updateTranslation: _this.updateTranslation, variable: variable, onReplaceImage: _this.chooseImage }));
        };
        _this.retryUpload = function () {
            if (!_this.props.uploadId) {
                return;
            }
            _this.props.uploadStore.retry(_this.props.uploadId);
        };
        _this.handleResize = function (width) {
            var updateData = {
                action: "update",
                path: _this.props.widgetManager.getPath(_this.props.element),
                toUpdate: { width: width },
            };
            _this.props.widgetManager.triggerEvent(new WidgetManager_1.WidgetEvent("image", updateData));
            _this.fireResizeTelemetry();
        };
        _this.handleAlignmentChange = function (alignment) {
            var updateData = {
                action: "update",
                path: _this.props.widgetManager.getPath(_this.props.element),
                toUpdate: { alignment: alignment },
            };
            _this.props.widgetManager.triggerEvent(new WidgetManager_1.WidgetEvent("image", updateData));
        };
        _this.updateImage = function (toUpdate) {
            var updateData = {
                action: "update",
                path: _this.props.widgetManager.getPath(_this.props.element),
                toUpdate: toUpdate,
            };
            _this.props.widgetManager.triggerEvent(new WidgetManager_1.WidgetEvent("image", updateData));
        };
        _this.deleteWidget = function () {
            var updateData = {
                action: "delete",
                path: _this.props.widgetManager.getPath(_this.props.element),
            };
            _this.props.widgetManager.triggerEvent(new WidgetManager_1.WidgetEvent("image", updateData));
        };
        _this.chooseImage = function () {
            var data = {
                action: "chooseImage",
                path: _this.props.widgetManager.getPath(_this.props.element),
            };
            _this.props.widgetManager.triggerEvent(new WidgetManager_1.WidgetEvent("image", data));
        };
        _this.isSupportedDragType = function (event) {
            var _a;
            var types = (_a = event.dataTransfer) === null || _a === void 0 ? void 0 : _a.types;
            return types && types.includes("Files");
        };
        _this.onEmptyImageDrop = function (event) {
            var _a, _b;
            if (((_b = (_a = event.dataTransfer) === null || _a === void 0 ? void 0 : _a.types) === null || _b === void 0 ? void 0 : _b.length) === 0) {
                return;
            }
            var dropType = event.dataTransfer.types[0];
            if (dropType === "application/json") {
                event.preventDefault();
                event.stopPropagation();
                _this.onDropToken(event);
            }
            else if ((0, WidgetBehaviours_1.isImageDrop)(event)) {
                event.preventDefault();
                event.stopPropagation();
                _this.onDropImage(event);
            }
        };
        _this.onDropToken = function (event) {
            var variable = (0, VariableActions_1.getVariableTokenFromDragEvent)(event);
            if (!variable) {
                return;
            }
            var eventData = {
                action: "dropVariable",
                path: _this.props.widgetManager.getPath(_this.props.element),
                variable: variable,
            };
            _this.props.widgetManager.triggerEvent(new WidgetManager_1.WidgetEvent("image", eventData));
        };
        _this.onDropImage = function (event) {
            var _a;
            var file = (_a = event.dataTransfer) === null || _a === void 0 ? void 0 : _a.files[0];
            if (!file) {
                return;
            }
            var eventData = {
                action: "dropImage",
                path: _this.props.widgetManager.getPath(_this.props.element),
                file: file,
            };
            _this.props.widgetManager.triggerEvent(new WidgetManager_1.WidgetEvent("image", eventData));
        };
        _this.selectFrameType = function (newFrame) {
            if (newFrame === _this.props.frame) {
                return;
            }
            var delta = {
                frame: newFrame,
            };
            if (newFrame === Image_2.ImageFrame.Circle) {
                if (_this.aspectRatio && _this.aspectRatio > 1) {
                    if (typeof _this.props.width === "number") {
                        delta.width = _this.props.width / _this.aspectRatio;
                    }
                    delta.aspectRatio = _this.aspectRatio;
                }
            }
            else {
                if (_this.aspectRatio && _this.aspectRatio > 1) {
                    if (typeof _this.props.width === "number") {
                        delta.width = Math.min(100, _this.props.width * _this.aspectRatio);
                    }
                }
                _this.tempTranslation = { x: 0, y: 0 };
                _this.tempScale = 1;
                _this.confirmRepositioning();
            }
            _this.updateImage(delta);
        };
        _this.startRepositioning = function () {
            _this.tempScale = _this.props.scale;
            _this.tempTranslation = {
                x: _this.props.translationX,
                y: _this.props.translationY,
            };
            _this.menuState = ImageWidgetMenu_1.ImageWidgetMenuState.Repositioning;
        };
        _this.confirmRepositioning = function () {
            _this.updateImage({
                translation: _this.tempTranslation,
                scale: _this.tempScale,
            });
            _this.menuState = ImageWidgetMenu_1.ImageWidgetMenuState.None;
        };
        _this.cancelRepositioning = function () {
            _this.tempScale = _this.props.scale || 1;
            _this.tempTranslation = {
                x: _this.props.translationX,
                y: _this.props.translationY,
            };
            _this.menuState = ImageWidgetMenu_1.ImageWidgetMenuState.None;
        };
        _this.zoomIn = function () {
            _this.setZoomLevel(_this.tempScale + 0.5);
        };
        _this.zoomOut = function () {
            _this.setZoomLevel(_this.tempScale - 0.5);
        };
        _this.setZoomLevel = function (newScale) {
            _this.tempScale = Math.max(exports.MIN_SCALE, Math.min(exports.MAX_SCALE, newScale));
        };
        _this.updateTranslation = function (newTranslation, forceUpdate) {
            if (forceUpdate === void 0) { forceUpdate = false; }
            _this.tempTranslation = lodash_1.default.clone(newTranslation);
            if (forceUpdate) {
                _this.confirmRepositioning();
            }
        };
        _this.delete = function (event) {
            event.preventDefault();
            _this.deleteWidget();
        };
        _this.onMenuStateChange = function (newState) {
            _this.menuState = newState;
        };
        _this.onMenuStateToggle = function (proposedState) {
            _this.menuState = _this.menuState === proposedState ? ImageWidgetMenu_1.ImageWidgetMenuState.None : proposedState;
        };
        _this.trackUpload = function () {
            _this.uploadProgress = _this.props.uploadStore.getUploadProgress(_this.props.uploadId);
            if (_this.uploadProgress) {
                if (_this.uploadProgress.url) {
                    _this.updateImage({
                        src: _this.uploadProgress.url,
                        uploadId: null,
                    });
                }
                else {
                    (0, mobx_1.autorun)(function (reaction) {
                        if (_this.uploadProgress && _this.uploadProgress.url) {
                            _this.updateImage({
                                src: _this.uploadProgress.url,
                                uploadId: null,
                            });
                            reaction.dispose();
                        }
                    });
                }
            }
        };
        _this.hasNoImageAndIsntUploading = function () {
            return !(_this.props.src || (_this.uploadProgress && _this.uploadProgress.dataUrl));
        };
        _this.tempScale = _this.props.scale;
        _this.tempTranslation = {
            x: _this.props.translationX,
            y: _this.props.translationY,
        };
        if (_this.props.uploadId) {
            _this.trackUpload();
        }
        _this.aspectRatio = _this.props.aspectRatio;
        return _this;
    }
    Object.defineProperty(ImageWidget.prototype, "isRepositionMode", {
        get: function () {
            return this.menuState === ImageWidgetMenu_1.ImageWidgetMenuState.Repositioning;
        },
        enumerable: false,
        configurable: true
    });
    ImageWidget.prototype.componentDidUpdate = function (prevProps) {
        var _this = this;
        if (!this.props.isSelected && prevProps.isSelected && this.isRepositionMode) {
            this.cancelRepositioning();
        }
        if (!this.props.toolbarBeingUsed && prevProps.toolbarBeingUsed) {
            (0, mobx_1.runInAction)(function () {
                _this.menuState = ImageWidgetMenu_1.ImageWidgetMenuState.None;
            });
        }
        if (!prevProps.uploadId && this.props.uploadId) {
            this.trackUpload();
        }
    };
    ImageWidget.prototype.render = function () {
        var _a;
        var _b = this.props, frame = _b.frame, isSelected = _b.isSelected, toolbarBeingUsed = _b.toolbarBeingUsed, width = _b.width, renderMargins = _b.renderMargins, children = _b.children, attributes = _b.attributes;
        var widthPercent = 100;
        if (!!width && typeof width === "number") {
            widthPercent = width;
        }
        var showMenu = (isSelected || toolbarBeingUsed) && (!this.uploadProgress || this.uploadProgress.state === UploadService_1.UploadState.Success);
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", __assign({ className: (0, classnames_1.default)("image-widget", {
                    "image-widget--selected": isSelected,
                }, "image-widget--margin-".concat(renderMargins)) }, attributes),
                react_1.default.createElement(ResizerComponent_1.default, { width: width || 100, alignment: this.props.alignment, handleResize: this.handleResize, handleAlignmentChange: this.handleAlignmentChange, isSelected: this.props.isSelected, aspectRatio: frame === Image_2.ImageFrame.Circle ? 1 : (_a = this.aspectRatio) !== null && _a !== void 0 ? _a : 1, preserveAspectRatio: true },
                    react_1.default.createElement(react_1.default.Fragment, null,
                        this.renderInner(),
                        this.renderLoading())),
                showMenu && this.renderMenu(widthPercent),
                children)));
    };
    ImageWidget.prototype.fireResizeTelemetry = function () {
        this.props.telemetry.inlineContentResized(EditorTypes_1.BlockType.Image);
    };
    var _a, _b, _c, _d;
    ImageWidget.defaultProps = {
        frame: Image_2.ImageFrame.None,
        scale: 1,
        translationX: 0,
        translationY: 0,
        renderMargins: ImageWidgetMarginOption.Both,
        width: 0,
        alt: "",
        role: "",
    };
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", typeof (_a = typeof HTMLElement !== "undefined" && HTMLElement) === "function" ? _a : Object)
    ], ImageWidget.prototype, "imageElem", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Number)
    ], ImageWidget.prototype, "aspectRatio", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", typeof (_b = typeof ImageWidgetMenu_1.ImageWidgetMenuState !== "undefined" && ImageWidgetMenu_1.ImageWidgetMenuState) === "function" ? _b : Object)
    ], ImageWidget.prototype, "menuState", void 0);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], ImageWidget.prototype, "isRepositionMode", null);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Number)
    ], ImageWidget.prototype, "tempScale", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", typeof (_c = typeof Image_2.ICoordinate !== "undefined" && Image_2.ICoordinate) === "function" ? _c : Object)
    ], ImageWidget.prototype, "tempTranslation", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", typeof (_d = typeof UploadStore_1.IUploadProgress !== "undefined" && UploadStore_1.IUploadProgress) === "function" ? _d : Object)
    ], ImageWidget.prototype, "uploadProgress", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], ImageWidget.prototype, "startRepositioning", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], ImageWidget.prototype, "confirmRepositioning", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], ImageWidget.prototype, "cancelRepositioning", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], ImageWidget.prototype, "zoomIn", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], ImageWidget.prototype, "zoomOut", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], ImageWidget.prototype, "setZoomLevel", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], ImageWidget.prototype, "updateTranslation", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], ImageWidget.prototype, "onMenuStateChange", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], ImageWidget.prototype, "onMenuStateToggle", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], ImageWidget.prototype, "trackUpload", void 0);
    ImageWidget = __decorate([
        mobx_react_1.observer,
        __metadata("design:paramtypes", [Object])
    ], ImageWidget);
    return ImageWidget;
}(react_1.default.Component));
exports.default = ImageWidget;
